<template>
  <div class="flex items-center w-full justify-end mt-4 gap-1">
    <!-- TODO: Hide for now -->
    <!--    <div class="per-page flex items-center mr-4">-->
    <!--      <p class="text-sm mr-2 whitespace-nowrap text-gray-400">-->
    <!--        {{ $t('history.content.footer.per-page') }}-->
    <!--      </p>-->
    <!--      <select-->
    <!--        v-model="perPage"-->
    <!--        class="form-control text-sm ps-2 flex-grow-0 w-auto"-->
    <!--      >-->
    <!--        <option-->
    <!--          v-for="itemsLimit in [10, 20, 30, 40, 50]"-->
    <!--          :key="itemsLimit"-->
    <!--          :value="itemsLimit"-->
    <!--        >-->
    <!--          {{ itemsLimit }}-->
    <!--        </option>-->
    <!--      </select>-->
    <!--    </div>-->
    <ChButton
      rounded
      :variant="ButtonVariant.CLEAR"
      :color="ColorScheme.SECONDARY"
      icon="chevron-double-left"
      @click="goFirst"
      :disabled="page === 1"
    />
    <ChButton
      rounded
      :variant="ButtonVariant.CLEAR"
      :color="ColorScheme.SECONDARY"
      icon="chevron-left"
      @click="goPrevious"
      :disabled="page === 1"
    />
    <ChButton
      rounded
      :variant="ButtonVariant.CLEAR"
      :color="ColorScheme.SECONDARY"
      icon="chevron-right"
      @click="goNext"
      :disabled="page >= totalPages"
    />
    <ChButton
      rounded
      :variant="ButtonVariant.CLEAR"
      :color="ColorScheme.SECONDARY"
      icon="chevron-double-right"
      @click="goLast"
      :disabled="page >= totalPages"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed, watch } from 'vue'
  import { ButtonVariant, ChButton, ColorScheme } from '@chatlyncom/chatlyn-ui-components'

  const props = defineProps({
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 10,
    },
    count: {
      type: Number,
      required: true,
    },
  })

  const emits = defineEmits(['update:page', 'update:limit'])

  const perPage = computed({
    get() {
      return props.limit
    },
    set(value) {
      emits('update:limit', value)
    },
  })

  const totalPages = computed(() => Math.ceil(props.count / props.limit))

  const updatePage = (page: number) => {
    emits('update:page', page)
  }

  const goFirst = () => {
    updatePage(1)
  }

  const goPrevious = () => {
    updatePage(props.page - 1)
  }

  const goNext = () => {
    updatePage(props.page + 1)
  }

  const goLast = () => {
    updatePage(Math.ceil(props.count / props.limit))
  }

  watch(perPage, (value) => {
    localStorage.setItem('resourcePerPage', value.toString())
  })
</script>

<style scoped lang="scss"></style>
